<template>
	<div class="roles-warp">
	    <div class="roles-show">
	      <div class="roles" ref="roles">
	        <div class="rules-content">
	          <div class="rules-title">
	            Rank List
	          </div>
	          <div class="rules-detail">
	          	<ul class="ww-ul">
		    		<li>
		    			<div>NO.</div>
		    			<div>Name</div>
		    			<div>Time</div>
		    		</li>
		    		<li v-for="(item,index) in rankData" :key="index">
		    			<div>{{index+1}}</div>
		    			<div>
		    				<span v-if="item.user">
		    					{{item.user.nickname||""}}
		    				</span>
		    			</div>
		    			<div>{{item.time}}</div>
		    		</li>
		    	</ul>
	          </div>
	        </div>
	      </div>
	      <span class="iconfont close" @click="handleClick">&#xe6e2;</span>
	    </div>
	</div>
</template>

<script>
import { getRankList } from "@/util/data.js";
import { showToast } from "@/util/utils.js";
export default {
  data() {
    return {
    	rankData:[],
    };
  },
  created(){
	this.getRanks();
  },
  methods:{
    handleClick(){
      this.$emit("statusChanged",false);
    },
    getRanks(){
      getRankList({"activity_id":this.$route.params.id})
        .then((res) => {
          if (res.code === 1) {
          	var arr=[];
          	for(var i in res.data){
          		if(res.data[i].user){
          			arr.push(res.data[i]);
          		}
          		if(i==(res.data.length-1)){
          			this.dealTime(arr);
          		}
          	}
          } else {
          	var msg=res.message||res.msg||"Fail!";
            showToast(this, msg);
          }
        })
        .catch((err) => {
          showToast(this, "Fail!");
        });
    },
    dealTime(arr){
    	for(var i in arr){
    		var time=arr[i].score+"";
    		var timeArr=time.split('.');
    		var num=parseFloat(timeArr[0]);
    		var str=""; var str1=""; var str2=""; var str3="";
    		if(num>60){
    			if((Math.floor(num /60))<10){
    				str1="0"+Math.floor(num /60);
    			}
    			if((Math.floor(num /60))>=10){
    				str1=Math.floor(num /60);
    			}
    			if(num %60<10){
    				str2="0"+(num %60);
    			}
    			if(num %60>=10){
    				str2=(num %60);
    			}
    			str=str1+":"+str2;
    		}else{
    			if(num<10){
    				str2="0"+timeArr[0];
    			}
    			if(num>=10){
    				str2=timeArr[0];
    			}
    			str="00:"+str2;
    		}
    		if(timeArr[1]) {
    			// 先判断字符串的个数
    			if(timeArr[1].length==1){
    				str=str+"."+timeArr[1]+"0";
    			}else if(timeArr[1].length==2){
    				str=str+"."+timeArr[1];
    			}
    		}
    		else { str=str+".00"; }
    		arr[i].time=str;
			this.rankData=arr;
    	}
    }
  }
};
</script>

<style>
.roles-warp {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 6;
  background: rgba(0, 0, 0, 0.6);
}
.roles-warp .roles-show{
	width: 100%;
	max-width: 600px;
    left: 50%;
    top: 50%;
    position: absolute;
    transform: translate(-50%,-50%);
	overflow: hidden;
	padding: 40px 20px;
	color: white;
	background: #ffffff;
	border-radius: 7px;
}
.roles-warp .rules-detail{
	overflow-y: auto;
	min-height: 400px;
    max-height: 55vh;
	padding-right: 10px;
}
/*修改滚动条样式*/
.roles-warp .rules-detail::-webkit-scrollbar{
  width:5px;
  height:5px;
}
.roles-warp .rules-detail::-webkit-scrollbar-track{
  background: rgba(164,197,221,0.67);
  border-radius:0px;
}
.roles-warp .rules-detail::-webkit-scrollbar-thumb{
  background: #3E9AF9;
  border-radius:0px;
}
.roles-warp .rules-detail::-webkit-scrollbar-thumb:hover{
  background: #3E9AF9;
}
.roles-warp .rules-detail::-webkit-scrollbar-corner{
  background: #179a16;
}
.rules-content .rules-title{
	font-weight: bold;
    font-size: 22px;
    color: #0f173a;
    margin-bottom: 20px;
    text-align: center;
    margin: 20px 0 15px 0;
}
.roles-show .close{
	position: absolute;
    right: 15px;
    top: 15px;
    font-size: 20px;
    color: #1d1d1d;
    cursor: pointer;
    padding: 10px;
}
.rules-detail .ww-ul{
	font-size: 14px;
	font-weight: 400;
	color: #1d1d1d;
    border: 1px solid rgb(210,210,210);
}
.rules-detail .ww-ul li{
	overflow: hidden;
    text-align: center;
}
.rules-content .rules-detail .ww-ul li div{
	width: 44.25%;
	float: left;
    height: 43px;
    line-height: 43px;
}
.rules-content .rules-detail .ww-ul li div:first-of-type{
	width: 11.5%;
}
.rules-content .rules-detail .ww-ul li div:nth-of-type(2){
	border-left: 1px solid rgb(210,210,210);
	border-right: 1px solid rgb(210,210,210);
}
.rules-detail .ww-ul li:nth-of-type(1){font-weight: bold;}
.rules-detail .ww-ul li:nth-child(even){background: rgba(210,210,210,0.3);}
@media screen and (max-width: 768px){
	.roles-warp .roles-show{
		width: calc(100% - 30px);
	}
}
</style>



// WEBPACK FOOTER //
// src/components/rank.vue